<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12">
        <donation-search-form
          @click="onSearchClick"
          @change="onSearchResults"
          :pagination="pagination"
        ></donation-search-form>
      </b-col>
      <b-col cols="12" xl="7">
        <transition name="slide">
          <pagination-table
            :items="donations"
            :fields="[
              {key: 'person', label: 'Full Name'},
              {key: 'status'},
              {key: 'amount'},
              {key: 'actions'},,
            ]"
            :pagination="pagination"
            :is-loading="isLoading"
            @change="onPaginationChange"
            item-url="donation/{id}"
          >
          </pagination-table>
        </transition>
      </b-col>
      <b-col cols="12" xl="5">
        <flash-message transitionIn="animated swing"></flash-message>
        <b-card>
          <div slot="header">
            <strong>Donation</strong>
          </div>
          <donation-form :add-option="true"></donation-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import {RepositoryFactory} from "../../services/repositories/RepositoryFactory";
  import {PaginationMeta} from "../../models/PaginationMeta";
  import DonationForm from "../../components/donation/DonationForm";
  import PaginationTable from "../../components/base/PaginationTable";
  import DonationSearchForm from "../../components/donation/DonationSearchForm";

  const DonationRepo = RepositoryFactory.get('donation')

  export default {
    name: 'donations',
    components: {
      DonationSearchForm,
      PaginationTable,
      DonationForm
    },
    data() {
      return {
        donations: [],
        isLoading: true,
        pagination: new PaginationMeta(),
        searchParams: {},
      }
    },
    mounted() {
      DonationRepo
        .get()
        .then(
          response => (
              this.donations = response.data.data,
              this.pagination = response.data.meta,
              this.isLoading = false
          )
        )
    },
    methods: {
      onSearchResults(response) {
        this.donations = response.data
        this.pagination = response.meta
        this.isLoading = false
      },
      onSearchClick(params) {
        this.isLoading = true
        this.searchParams = params
      },
      onPaginationChange(){
        this.searchParams.page = this.pagination.page;
        this.searchParams.limit = this.pagination.limit;

        DonationRepo
          .searchDonations(this.searchParams)
          .then(
            response => (
                this.donations = response.data.data,
                this.pagination = response.data.meta,
                this.isLoading = false
            )
          )
      },
    }
  }
</script>
